export const GET_CURRENT_USER_QUERY = `
    query graphql {
       currentUser {
            id
            username
            first_name
            last_name
            email
            phone
            avatar
        },
        userPreferences {
            key
            value
        },
    }

`;

export const GET_CURRENT_USER_PERMISSIONS_QUERY = `
    query currentPermissions($project_id: Int, $workspace_id: Int, $account_id: Int) {
        currentPermissions(project_id: $project_id, workspace_id: $workspace_id, account_id: $account_id)
    }
`;

export const GET_CURRENT_USER_SOCIAL_CHANNELS_QUERY = `
    query CurrentUserSocialChannels($page: Int, $limit: Int) {
        currentUserSocialChannels(page: $page, limit: $limit) {
            total
            per_page
            current_page
            from
            to
            last_page
            has_more_pages
            data {
                id
                type
                url
                label
            }
        }
    }
`;

export const GET_CURRENT_USER_PREFERENCES_QUERY = `
    query UserPreferences {
        userPreferences {
            key
            value
        }
    }
`;
